import * as React from 'react';

import { TableCell, TableRow } from 'components/table';
import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';
import Entity from 'components/entity/Entity';
import CampaignEntityAvatar from 'components/entity/entity-avatar/CampaignEntityAvatar';
import CampaignEntityName from 'components/entity/entity-name/CampaignEntityName';
import CampaignState from 'components/campaign-state/CampaignState';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./user-notifications-row.i18n.json'));

import type { UserNotification, UserNotificationType } from 'types';

type Props = {
  notification: UserNotification,
  onChange: (notificationId: number, allowNotifications: boolean, type: UserNotificationType) => void
};

class UserNotificationsRow extends React.PureComponent<Props> {
  handleCheckboxClick = (): void => {
    const { notification, onChange } = this.props;

    onChange(notification.id, !notification.allowNotifications, 'campaign');
  };

  renderCampaignStatus = (): JSX.Element => {
    const { campaign } = this.props.notification;
    const campaignState = campaign.state;

    return (
      <CampaignState
        state={campaignState}
        message={__t(`user_notifications_row.campaign_state.${campaignState}`)}
      />
    );
  };

  renderCampaignEntity = (): JSX.Element => {
    const { notification } = this.props;
    const { campaign } = notification;

    return (
      <Entity>
        <CampaignEntityAvatar
          campaign={campaign}
          bordered
          form="square"
          size="medium"
        />
        <CampaignEntityName
          campaign={campaign}
          maxLength={250}
          style={{
            maxWidth: 250,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
          }}
          multiline
          size="small"
        />
      </Entity>
    );
  };

  render(): React.ReactNode {
    const { notification } = this.props;

    return (
      <TableRow>
        <TableCell width="big">
          {this.renderCampaignEntity()}
        </TableCell>
        <TableCell width="fill">
          {this.renderCampaignStatus()}
        </TableCell>
        <TableCell width="medium">
          <InputCheckbox
            id={`checkbox-${notification.id}`}
            name={`checkbox-${notification.id}`}
            checked={notification.allowNotifications}
            onChange={this.handleCheckboxClick}
          />
        </TableCell>
      </TableRow>
    );
  }
}

export default UserNotificationsRow;
